import { render } from "./AIFloatingRecorder.vue?vue&type=template&id=70864a5c&scoped=true&ts=true"
import script from "./AIFloatingRecorder.vue?vue&type=script&lang=ts"
export * from "./AIFloatingRecorder.vue?vue&type=script&lang=ts"

import "./AIFloatingRecorder.vue?vue&type=style&index=0&id=70864a5c&scoped=true&lang=css"

import exportComponent from "../../../../sf-playbook-app/APP/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70864a5c"]])

export default __exports__